import { html, strMap } from 'fxjs/es';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { NessCoreTmplS } from '../../../../../Core/S/Tmpl/module/NessCoreTmplS.js';
import { NessAppPlusProductTmplS } from '../../../Product/S/Tmpl/module/NessAppPlusProductTmplS.js';
import { NessAppPlusHomeTmplS } from './module/NessAppPlusHomeTmplS.js';
import { NessCoreConstantS } from '../../../../../Core/S/Constant/module/NessCoreConstantS.js';

export const limitedProduct = (limited_products, { limited_product_count, is_mobile }) => {
  return html`
    <div class="ness-limited-product__wrapper">
      <div class="ness-limited-product" data-length="${limited_products.length}">
        ${NessAppPlusHomeTmplS.homeTitle({
          link:
            limited_product_count > 3
              ? UtilS.makeApiUrl('/:lang/@/product/list/:type', { lang: T.lang, type: 'limit' })
              : '',
          title: ET('ness::product::product_06'),
          sub_title:
            limited_product_count > 3
              ? ET('ness::home::home_03', {
                  count: html`<span class="count">${UtilS.commify(limited_product_count)}</span>`,
                })
              : '',
          title_color: NessCoreConstantS.colors.white,
          sub_title_color: NessCoreConstantS.colors.blue,
        })}
        <div class="ness-limited-product__items-swiper">
          <div class="ness-limited-product__items-wrapper swiper-container">
            <div class="ness-limited-product__items swiper-wrapper">
              ${strMap((product) => {
                return NessAppPlusProductTmplS.nessProductNonLazyLoadTmpl(
                  product,
                  is_mobile,
                  'ness-limited-product__item swiper-slide',
                );
              }, limited_products)}
            </div>
          </div>
          ${is_mobile || limited_products.length <= 3
            ? ''
            : html`
                <div class="ness-limited-product__controller">
                  <div class="ness-limited-product__controller--left swiper-button-disabled">
                    ${NessCoreTmplS.nessLeftIcon({ color: NessCoreConstantS.colors.white })}
                  </div>
                  <div class="ness-limited-product__controller--right">
                    ${NessCoreTmplS.nessRightIcon({ color: NessCoreConstantS.colors.white })}
                  </div>
                </div>
              `}
        </div>
      </div>
    </div>
  `;
};
